import Phaser from "phaser";
import type { PanelStyleToken } from "./tokens.js";

/**
 * 표준 NineSlice 패널 — `PanelStyleToken` 토큰 기반.
 *
 * NineSlice 배경 1장만 생성. 자식 콘텐츠는 호출자가 별도 Container에 조립.
 * width/height는 호출자가 지정 (PanelStyleToken에는 sizing 없음 — 사용처마다 다름).
 *
 * 사용 예:
 * ```ts
 * const bg = new NineSlicePanel(scene, 0, 0, {
 *   style: PANEL_STYLES.parchment,
 *   width: DIALOGUE_PANEL.width,
 *   height: DIALOGUE_PANEL.height,
 * });
 * this.add(bg);
 * ```
 */
export class NineSlicePanel extends Phaser.GameObjects.NineSlice {
  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    options: {
      readonly style: PanelStyleToken;
      readonly width: number;
      readonly height: number;
      /** Origin x (default 0 = 좌측 기준). */
      readonly originX?: number;
      /** Origin y (default 0 = 상단 기준). */
      readonly originY?: number;
    },
  ) {
    const { style, width, height } = options;
    super(
      scene,
      x,
      y,
      style.textureKey,
      undefined,
      width,
      height,
      style.border.left,
      style.border.right,
      style.border.top,
      style.border.bottom,
    );
    this.setOrigin(options.originX ?? 0, options.originY ?? 0);
  }
}
